import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { useCurrentUser } from "./use-current-user";
import { ALL_USERS, getAllUsers } from "../api/user-request";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useEffect } from "react";
import {
  setChatUsers,
  updateLastMessage as updateLastMessageDux,
  UpdateChatUsersPayload,
} from "../redux/slices/chat-users-slice";
import { useSelectedUser } from "./use-selected-user";

const users = async (userId: number) => {
  const response = await getAllUsers(userId);
  return response.data;
};

export const useChatUsers = (loadUsers?: boolean) => {
  const { user } = useCurrentUser();
  const dispatch = useAppDispatch();
  const chatUsers = useAppSelector((state) => state.chatUsers.value);
  const { setSelectedUser } = useSelectedUser();

  const { data, isSuccess, isLoading, isError, refetch } = useQuery({
    queryKey: [ALL_USERS],
    queryFn: () => users(user?.id ?? 1),
    enabled: !!loadUsers,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const updateLastMessage = useCallback(
    (payload: UpdateChatUsersPayload) => {
      dispatch(updateLastMessageDux(payload));
    },
    [dispatch],
  );

  useEffect(() => {
    if (loadUsers) {
      if (isError) {
        dispatch(setChatUsers([]));
      }
      if (isSuccess) {
        dispatch(setChatUsers(data));
        setSelectedUser(data[0]);
      }
    }
  }, [data, dispatch, isError, isSuccess, loadUsers, setSelectedUser]);

  return {
    users: chatUsers,
    loading: isLoading,
    loadUser: refetch,
    updateLastMessage,
  };
};
